"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var getURL_native_exports = {};
__export(getURL_native_exports, {
  getURL: () => getURL
});
module.exports = __toCommonJS(getURL_native_exports);
var import_getDevServer = require("./getDevServer");
var hasWarnedOnce = false;
function getURL() {
  var url = process.env.ONE_SERVER_URL;
  if (url) {
    return url.replace(/\/+$/, "");
  }
  if (__DEV__) {
    if (!hasWarnedOnce) {
      hasWarnedOnce = true;
      console.warn(`The ONE_SERVER_URL environment variable is not set. While things will work in development mode as we'll be using your development server, you should still set ONE_SERVER_URL in your .env file for your production builds to work.`);
    }
    var { url: devServerUrl } = (0, import_getDevServer.getDevServer)();
    url = devServerUrl;
  }
  if (!url) {
    url = "http://one-server.example.com";
  }
  return url.replace(/\/+$/, "");
}
//# sourceMappingURL=getURL.native.js.map
